module.exports = __webpack_public_path__ + "img/facebook-share.67b3d2d1.svg";